<template>
	<div v-if="videoObject" class="c-frontpage-video">
		<BaseH2
			v-if="title"
			class="text-h3 text-gray-darker mb-xs/v"
			v-html="title"
		/>
		<div class="c-frontpage-video__container">
			<CookieInformationBlocker
				:categories="
					[
						statistic && 'statistic',
						functional && 'functional',
						marketing && 'marketing',
					].filter(Boolean)
				"
			>
				<VideoPlayer
					class="c-frontpage-video__video"
					:picker="videoObject"
					embed-on-play
				>
					<template #overlay="{ overlay, service }">
						<button
							:class="[
								'group flex justify-center items-center',
								'relative w-full h-full bg-black bg-opacity-20',
								'duration-300 delay-200 ease-smooth-out',
								{
									'opacity-0 pointer-events-none ':
										!overlay.isVisible,
								},
							]"
							@click.prevent="
								() => {
									service.play(overlay.hide);
									loading = true;
								}
							"
						>
							<img
								v-if="service.poster"
								:src="service.poster"
								:class="[
									'absolute top-0 left-0 ',
									'w-full h-full object-cover',
									,
								]"
							/>

							<div
								class="
									absolute
									cursor-pointer
									w-full
									z-10
									h-full
									bg-black bg-opacity-20
									flex flex-col
									items-start
									justify-end
								"
							>
								<BaseButton
									tag="div"
									class="
										px-sm/h
										bg-white
										group-hover:bg-theme-10
										text-theme
										m-xs/v
										>=1024:ml-3xl/v >=1024:mb-lg/h
									"
									v-text="'Afspil'"
								/>
							</div>
						</button>
					</template>
				</VideoPlayer>
			</CookieInformationBlocker>
		</div>
	</div>
</template>

<script>
import CookieInformationBlocker from '~/components/main/CookieInformationBlocker';
import { VideoPlayer } from '~/components/shared/VideoPlayer';

export default {
	name: 'BlockListVideo',

	components: { CookieInformationBlocker, VideoPlayer },

	inheritAttrs: false,

	props: {
		title: String,
		showTitleInToc: Boolean,
		text: String,

		videoContent: Object,
		fullWidthView: Boolean,
	},

	data() {
		return {
			loading: false,
		};
	},

	computed: {
		statistic() {
			return this.videoContent.content?.statistic;
		},
		functional() {
			return this.videoContent.content?.functional;
		},
		marketing() {
			return this.videoContent.content?.marketing;
		},

		videoAlias() {
			return (
				this.videoContent.content?.video.provider.alias ||
				'blockYouTube'
			);
		},
		videoObject() {
			return this.videoContent.content?.video;
		},

		overlayLabel() {
			const list = [
				`block-${this.$vnode.key}__overlay-button`,
				this.title && `block-${this.$vnode.key}__title`,
			];
			return list.filter(Boolean).join(' ');
		},
	},
};
</script>

<style lang="postcss">
.c-frontpage-video__container {
	@apply relative w-screen;
	left: calc(var(--theme-layout-margin, 0px) * -1);
	@screen >=1441 {
		left: calc(
			(100vw - var(--theme-layout-max, 1440px)) / -2 +
				var(--theme-layout-margin, 0px) * -1
		);
	}
}
.c-frontpage-video__video {
	height: 100%;
	min-width: 100%;
	object-fit: cover;
	max-height: 70vh;
	display: block;
	aspect-ratio: 16 / 9;
}

.c-frontpage-video__overlay {
	@apply absolute
				cursor-pointer
				w-full
				z-10
				h-full
				flex flex-col
				items-start
				justify-end;
}
</style>
